import './pagenotfound.css';
import { Link } from 'react-router-dom';

const PageNotFound=()=>{
	return (
		<div className="pagenotfound-container">
			<div className="pagenotfound-container-left">
				<div className="pagenotfound-top">
					<h1>404</h1>
					<h2>Page Not Found</h2>
				</div>
				<div className="pagenotfound-body">
					<p>Siamo spiacenti, ma non siamo riusciti a trovare la risorsa richiesta.</p>
					<button className='gradient-button'><Link to="/">Torna alla Dashboard</Link></button>
				</div>
			</div>
			<div className="pagenotfound-container-right">
			</div>
		</div>
	);
};

export default PageNotFound;
